export default "__VITE_ASSET__270999bf__"